var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ColorValueSearchHandler',_vm._b({attrs:{"black-checkmarks-colors-ids":_vm.blackCheckmarksColorsIds}},'ColorValueSearchHandler',_vm.legacySearchService.getFacetComponentBindings(_vm.handler),false))}
var staticRenderFns = []

export { render, staticRenderFns }